import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { CookieService } from 'ngx-cookie-service';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { UserStatusDataValidator } from './validators/data.validators';

const CLASS_NAME = 'UserStatusDao';

@Injectable()
export class UserStatusDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.statusDAO, new DefaultRetryHandler(), new UserStatusDataValidator(), log, cookieService);
  }

  public get(): Observable<any> {
    return this.doGet(this.daoConfig.url);
  };
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/user-status.dao.ts